module.exports = __webpack_public_path__ + "img/payment.7be43f88.webp";